<template lang="pug">
#FeatureInfo.absolute.bg-white.ba.b--gray.pa2.f4.br3.shadow-3(v-show="show" :class="{ visible: true || show }" @click="close")
    div(v-if="p")
        span.b {{ p.Name_rgn }}
        span(v-if="p.altname") , or
            span.b  {{ p.altname }}
            span ,
        span  is {{ classArticle }}.
        span(v-if="official == 2")  The area is not official but under consideration.
        span(v-if="official == 3")  The area is not official but under consideration.
        span(v-if="official == 4")  The area is not official but under consideration.
        span(v-if="official == 5")  The area is not official but under consideration.
        span(v-if="official == 6")  The designation is unofficial.
        span(v-if="official == 9")  The designation is unofficial.
        .mt3.ml2

            .stat(v-if="stats.latitude.value")
                img.icon(:src="stats.latitude.icon")
                //- .value {{ stats.latitude.value.toFixed(1) }}°
                .value {{ degToDMS(stats.latitude.value) }}
            .stat(v-if="stats.elev.value")
                img.icon(:src="stats.elev.icon")
                .value {{ stats.elev.value}}m / {{ (stats.elev.value * 3.28084).toFixed(0) }}'
            .stat(v-if="stats.GI_area.value")
                img.icon(:src="stats.GI_area.icon")
                .value {{ stats.GI_area.value}} ha.
            .stat(v-if="stats.auv.value")
                img.icon(:src="stats.auv.icon")
                .value {{ stats.auv.value}} ha.
            .stat(v-if="stats.climate.value")
                img.icon(:src="stats.climate.icon")
                .value {{ stats.climate.value}}
            .stat(v-if="stats.ppt_yr.value")
                img.icon(:src="stats.ppt_yr.icon")
                .value {{ stats.ppt_yr.value}} mm, annual
            .stat(v-if="stats.ppt_gs.value")
                img.icon(:src="stats.ppt_gs.icon")
                .value {{ stats.ppt_gs.value}} mm, growing season
            .stat(v-if="stats.GDD_1.value")
                img.icon(:src="stats.GDD_1.icon")
                .value {{ stats.GDD_1.value}} growing degree days
            .stat(v-if="stats.style.value")
                img.icon(:src="stats.style.icon")
                .value {{ stats.style.value}}

</template>

<script>
import { EventBus } from '../EventBus';
import indefinite from 'indefinite';
const statsIcons = [
    { prop: 'latitude', icon: 'WWR003_latitude.png' },
    { prop: 'elev', icon: 'WWR003_elev.png' },
    { prop: 'GI_area', icon: 'WWR003_area.png' },
    { prop: 'auv', icon: 'WWR003_vinearea.png' },
    { prop: 'climate', icon: 'WWR003_climate.png' },
    { prop: 'ppt_yr', icon: 'WWR003_precip.png' },
    { prop: 'ppt_gs', icon: 'WWR003_precip_gs.png' },
    { prop: 'GDD_1', icon: 'WWR003_thermom.png' },
    { prop: 'style', icon: 'WWR003_wineglass.png' },
];
const demoMode = false;

export default {
    name: 'FeatureInfo',
    data: () => ({
        feature: undefined,
        show: false,
        ignoreProps: ['id', 'Longitude', 'Latitude', 'image_url'],
    }),
    computed: {
        p() {
            console.log(this.feature && this.feature.properties);
            return this.feature && this.feature.properties;
        },
        official() {
            return this.p.official || this.p.Official;
        },
        imageUrl() {
            return this.p && this.p.image_url;
        },
        classArticle() {
            return this.p && indefinite(this.p.class);
        },
        stats() {
            const ret = {};
            for (const stat of statsIcons) {
                ret[stat.prop] = {
                    prop: stat.prop,
                    value: this.p[stat.prop] || (demoMode ? 34 : null),
                    icon: `attribute_icons/${stat.icon}`,
                };
            }
            if (demoMode) {
                ret.climate.value = 'Hot summer, humid winter';
                ret.style.value = 'Sparkling, pinot gris';
            }
            return ret;
        },
    },
    created() {
        window.app.FeatureInfo = this;
        EventBus.$on('select-feature', (feature) => {
            if (!feature) {
                this.show = false;
            } else {
                this.feature = feature;
                this.show = true;
            }
        });
    },
    methods: {
        degToDMS(deg, dplaces = 0) {
            let d = Math.floor(deg); // make degrees
            let m = Math.floor((deg - d) * 60); // make minutes
            let s =
                Math.round(((deg - d) * 60 - m) * 60 * Math.pow(10, dplaces)) /
                Math.pow(10, dplaces); // Make sec rounded
            s == 60 && (m++, (s = 0)); // if seconds rounds to 60 then increment minutes, reset seconds
            m == 60 && (d++, (m = 0)); // if minutes rounds to 60 then increment degress, reset minutes
            const ns = d < 0 ? 'S' : 'N';
            return `${Math.abs(d)}° ${m}′ ${ns}`;
        },

        close() {
            this.show = false;
            window.attributeLoadCount = (window.attributeLoadCount || 0) + 1;
        },
    },
};
</script>

<style scoped>
#FeatureInfo {
    transition: opacity 0.3s;
    opacity: 0;
    left: 10px;
    top: 55px;
    margin-right: 44px;
    font-family: 'DIN';
}

@media only screen and (max-width: 639px) {
    #FeatureInfo {
        top: 70px;
    }
}

#FeatureInfo.visible {
    opacity: 1;
    transition: opacity 0.3s;
    /* display: block; */
}
#FeatureInfo th {
    text-align: right;
}

.image {
    width: 100%;
}

.stat {
    margin-top: 6px;
    font-size: 18px;
    display: flex;
    flex-direction: row;
}

.stat .icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    flex-grow: 0;
    align-self: center;
}

.stat .value {
    vertical-align: top;
    margin-left: 12px;
    margin-top: 2px;
    display: inline-block;
    flex-grow: 1;
}
</style>
